export default __webpack_public_path__ + "static/media/checkmark_icon.ff4c4c46.png";